export default function WhatWeDo() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-[1100px] mx-auto px-6">
        <div className="md:text-center text-left mb-12">
          <h2 className="text-3xl font-bold text-[#7A5A44] mb-6 leading-relaxed">
            おうちの相談室とは
          </h2>
          <p className="text-[#5A4033] text-lg leading-[1.8] mb-4 md:mb-4 mb-0">
            おうちの相談室は、話を聞いて終わる場所ではありません。
          </p>
          <p className="text-[#5A4033] text-lg leading-[1.8] mb-4 md:mb-4 mb-0">
            住まいに関する選択を「正しく前に進めるため」のコンサルティングサービスです。
          </p>
          <p className="text-[#5A4033] text-lg leading-[1.8] mb-4 md:mb-4 mb-0">
            家を建てる、買う、売る。
          </p>
          <p className="text-[#5A4033] text-lg leading-[1.8] mb-4 md:mb-4 mb-0">
            その一つひとつには、大きなお金と長い時間が関わります。
          </p>
          <p className="text-[#5A4033] text-lg leading-[1.8] mb-4 md:mb-4 mb-0">
            だからこそ、感覚や勢いで決めるべきではありません。
          </p>
          <p className="text-[#5A4033] text-lg leading-[1.8] mb-4 md:mb-4 mb-0">
            状況を整理し、選択肢を並べ、どの道があなたにとって最適なのかを一緒に考え、決断と実行まで伴走します。
          </p>
          <p className="text-[#5A4033] text-lg leading-[1.8] mb-4 md:mb-4 mb-0">
            最終的に決めるのはお客様自身。
          </p>
          <p className="text-[#5A4033] text-lg leading-[1.8]">
            その判断が「間違っていなかった」と言える状態まで、プロとして関わり続けます。
          </p>
        </div>

        <div className="mb-12">
          <img
            src="https://public.readdy.ai/ai/img_res/12495d2e3d83971844c09c2a58ef85ae.jpg"
            alt="相談の様子"
            className="w-full h-auto rounded-2xl shadow-[0_6px_18px_rgba(0,0,0,0.08)]"
          />
        </div>
      </div>
    </section>
  );
}